import React from 'react'
import { Link } from 'react-router-dom'
import Services from "../../api/Services";

const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const EarthSolution = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12">
                        <div className="wpo-section-title-s2">
                            {/* <h2>What We Offer</h2> */}
                            <h3>Earth Solution</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {Services.slice(0, 18).map((service, index) => (
                        <div className="col-lg-4 col-md-6 col-12" key={index}>
                            <div className="service-card">
                                <div className="image">
                                    <img src={service.image} alt="" />
                                    <span>{index + 1}</span>
                                    <div className="line-one"></div>
                                    <div className="line-two"></div>
                                </div>
                                <div className="content">
                                    {/* <div className="icon">
                                        <img src={service.icon} alt="" />
                                    </div> */}
                                    <h2><Link onClick={ClickHandler} to={`/service-details/${service.slug}`}>{service.title}</Link></h2>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default EarthSolution;